import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss', './headers.css']
})
export class LandingComponent {

  constructor(private auth: AuthService) {}  

  login(): void {
    this.auth.login();
  }
  
  signup(): void {
    this.auth.signup();
  }

  redirectToEnterPrise() {
    this.openExternal('https://gpswebshop.com/products/geoastra-ntrip-caster-enterprise-edition-12-month-subscription-service?variant=47996976169268');
  }

  redirectToPro() {
    this.openExternal('https://gpswebshop.com/products/geoastra-ntrip-caster-pro-edition-1-month-subscription-service?variant=47997022535988');
  }
  
  private openExternal(url: string): void {
    const win = window.open(url, '_blank', 'noopener');
    if (win) {
      win.opener = null;
    }
  }
}
